// extracted by mini-css-extract-plugin
export default {"tagsContainer":"filterTags-module__tagsContainer--PUKZz","tag":"filterTags-module__tag--wZX4W","active":"filterTags-module__active--ZhNZu"};